// extracted by mini-css-extract-plugin
module.exports = {"root":"_2g_H9","rune":"_3ZZlU","spin":"_3kamR","gem":"dVnu5","auth":"_3SLW8","app":"_2xkOJ"};